import { styled } from '@mui/material';

export const HorizontalRuler = styled('hr')`
  border: 0;
  border-top: ${({ theme }) => `1px solid ${theme.palette.common.lightGrey}`};
`;
